import api, { apiPrefix } from './Api';
import {
  WishlistLine,
  wishlistLineFromResponse,
} from '../interfaces/Wishlist/WishlistLine';

const wishlistApiPrefix = `${apiPrefix}/wishlists`;

export const addProductToWishlist = (productID: number) => {
  const bodyFormData = new FormData();
  bodyFormData.append('product_id', productID.toString());

  return api.post(wishlistApiPrefix, bodyFormData);
};

export const getWishlist = async (): Promise<WishlistLine[]> => {
  const response = await api.get(wishlistApiPrefix);

  return (response.data?.data ?? []).map(wishlistLineFromResponse);
};

export const removeProductFromWishlist = async (
  productID: number,
): Promise<void> => api.delete(`${wishlistApiPrefix}/${productID}`);
